import InverterStringLine from "./InverterStringLine";
import InverterString from "../lib/InverterString";
import { Global } from "../utilities/global";

export default function genarateStringLines(selectedInv: any, layer: any): InverterStringLine[] {
    let stringTree: InverterStringLine[] = [];
    selectedInv.subGenerators.forEach((subGenerator: any) => {
        let strs: InverterString;
        let localStringID = 1;
        let invPanelCount = 0; //  count at inverter level
        if(subGenerator.strings)
        subGenerator.strings.forEach((string: any) => {
            strs =  (new InverterString(localStringID, subGenerator.inverterID, string.panelCount, string.color, string.name, subGenerator.name));
            invPanelCount += string.panelCount;
            localStringID++;
            stringTree.push(new InverterStringLine(strs, string.panelCount, string.color, layer));
        });
    });
    // console.log(stringTree);
    Global.stringTree = stringTree;
    return stringTree;
}